// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"4172": "d475d337","5386": "65aea62a","9903": "87b14f40",}[chunkId] + ".css"
}